import { addShortTask, getLanguages, analysis } from '@api/public';
import { getNotice } from '@api/longVideo';

const historySearch = (localStorage.getItem('historySearch') && JSON.parse(localStorage.getItem('historySearch'))) || [];

//  初始化public
const initStatePublicConfig = {
  login_ways_config_key: {
    phone_login: 0,
    account_password_login: 0,
    account_login: 0,
    phone_password_login: 0,
    phone_password_login_code: 0,
    account_password_login_code: 0,
    account_login_code: 0,
    login_code: 0,
    phone_register: 0,
    account_register: 0
  }
};
const state = {
  afterChangeLangMethods: [],
  downloadPage: localStorage.getItem('downloadPage') || '',
  historySearch,
  languages: [],
  loadingShowFlag: false,
  scrollPositionY: 0,
  publicConfig: JSON.parse(localStorage.getItem('publicConfig')) || initStatePublicConfig,
  sysMaintenanceInfo: {},
  showHomeTips: false,
  isApp: localStorage.getItem('isApp') === '1', // 是否嵌套在app壳中（目前只有安卓）
  isWebClip: localStorage.getItem('isWebClip') === '1', // 是否是嵌套载ios轻应用里
  keyboardHeight: 0,
  marqueeText: [], // 跑马灯
  richText: [], // 富文本
  picAnnouncement: [], // 图片公告
  isShowAnnouncementPic: false, // 图片弹窗
  isShowAnnouncementApp: false, // 应用列表弹窗
  isShowAnnouncementRichText: false, // 图文弹窗
  isUserShowSkeleton: true, // 是否用户中心第一次加载展示骨架屏
  isHomeShowSkeleton: true, // 是否首页第一次加载展示骨架屏
  isShowUploadTips: false, // ai换脸上传时候的提示框
  uploadTipsType: 'loading', // ai换脸上传时候的提示类型
  searchCommunityNewsText: '', // 社区最新搜索
  searchCommunityEssenceText: '', // 社区精华搜索
  searchCommunityVideoText: '' // 社区视频搜索
};

const getters = {
  isH5: state => !state.isApp && !state.isWebClip
};

const mutations = {
  setAfterChangeLangMethods: (state, data) => {
    state.afterChangeLangMethods.forEach(item => {
      const index = data.findIndex(subItem => item.name.split(' ')[1] === subItem.name.split(' ')[1]);
      if (index !== -1) {
        data.splice(index, 1);
      }
    });
    state.afterChangeLangMethods = [...state.afterChangeLangMethods, ...data];
  },
  setDownloadPage: (state, data) => {
    state.downloadPage = data;
    localStorage.setItem('downloadPage', data);
  },
  setHistorySearch: (state, { data, isClear = false, isSingleClear = false }) => {
    if (isClear) {
      state.historySearch = [];
      localStorage.setItem('historySearch', JSON.stringify([]));
      return;
    }

    const historySearch = state.historySearch;

    if (historySearch.includes(data)) {
      const index = historySearch.findIndex(item => item === data);
      historySearch.splice(index, 1);
      if (isSingleClear) return;
      historySearch.unshift(data);
    } else {
      historySearch.unshift(data);
    }

    state.historySearch = [...historySearch];
    localStorage.setItem('historySearch', JSON.stringify(historySearch));
  },
  setLanguages: (state, data) => {
    state.languages = data;
  },
  setLoadingShowFlag: (state, data) => {
    state.loadingShowFlag = data;
  },
  setScrollPositionY: (state, data) => {
    state.scrollPositionY = data;
  },
  setPublicConfig: (state, data) => {
    state.publicConfig = data;
    localStorage.setItem('publicConfig', JSON.stringify(data));
  },
  setSysMaintenanceInfo: (state, data) => {
    state.sysMaintenanceInfo = data;
  },
  setShowHomeTips (state, data) {
    state.showHomeTips = data;
  },
  setIsApp (state, data) {
    state.isApp = data;
    localStorage.setItem('isApp', data ? '1' : '0');
  },
  setIsWebClip (state, data) {
    state.isWebClip = data;
    localStorage.setItem('isWebClip', data ? '1' : '0');
  },
  setKeyboardHeight (state, data) {
    state.keyboardHeight = data;
  },
  setMarqueeText (state, data) {
    state.marqueeText = data;
  },
  setRichText (state, data) {
    state.richText = data;
  },
  setPicAnnouncement (state, data) {
    state.picAnnouncement = data;
  },
  setIsShowAnnouncementPic (state, data) {
    state.isShowAnnouncementPic = data;
  },
  setIsShowAnnouncementApp (state, data) {
    state.isShowAnnouncementApp = data;
  },
  setIsShowAnnouncementRichText (state, data) {
    state.isShowAnnouncementRichText = data;
  },
  setIsUserShowSkeleton: (state, data) => {
    state.isUserShowSkeleton = data;
  },
  setIsHomeShowSkeleton: (state, data) => {
    state.isHomeShowSkeleton = data;
  },
  setIsShowUploadTips (state, data) {
    state.isShowUploadTips = data;
  },
  setUploadTipsType (state, data) {
    state.uploadTipsType = data;
  },
  setSearchCommunityNewsText (state, data) {
    state.searchCommunityNewsText = data;
  },
  setSearchCommunityEssenceText (state, data) {
    state.searchCommunityEssenceText = data;
  },
  setSearchCommunityVideoText (state, data) {
    state.searchCommunityVideoText = data;
  }
};

const actions = {
  addShortTask ({ commit }, params) {
    const token = localStorage.getItem('token');
    if (token) {
      addShortTask(params);
    }
  },
  getLanguages ({ commit }) {
    getLanguages().then(res => {
      if (res.result === 200000) {
        const list = res.data.list;
        list.forEach(item => {
          item.value = item.id;
          item.text = item.name;
        });
        commit('setLanguages', list);
      }
    });
  },
  analysis ({ commit }, params) {
    analysis(params);
  },
  getNoticeList ({ commit }, params) {
    // 1跑马灯 2公告
    getNotice().then(res => {
      if (res.result === 200000) {
        const marqueeText = res.data.list.filter(e => e.is_runner === 1);
        const picAnnouncement = res.data.list.filter(e => e.is_runner === 2);
        const richText = res.data.list.filter(e => e.is_runner === 3);

        commit('setMarqueeText', marqueeText);

        commit('setPicAnnouncement', picAnnouncement);

        if (richText.length) {
          commit('setRichText', [richText[0]]);
        }
      }
    }).catch(() => {
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
